// this is legacy
// move use  src/services/experiment/posthog.ts instead

import { PosthogService } from "@/services/posthog";
import { POSTHOG_EVENT } from "@/services/posthog/data";
import { TSignUpType } from "@/tracking/event-types";
import * as Sentry from "@sentry/react";

export const identifyUser = (uid: string, email: string) => {
  PosthogService.identify(email, {
    email,
    uid,
  });
};

export const signupCapture = (
  email: string,
  uid: string,
  signupType?: TSignUpType,
  signupSource?: string,
) => {
  PosthogService.capture(POSTHOG_EVENT.USER_SIGNED_UP, {
    $set: { email, uid },
    $set_once: { signup_through_website: true, sign_up: true },
    signuptype: signupType ?? "NA",
    signup_type: signupSource ?? "aftershoot",
  });

  try {
    // @ts-ignore
    window.ttq.track("CompleteRegistration");
  } catch (error) {
    Sentry.captureException(error);
  }
};

export const cardAddedEventCapture = (email: string) => {
  PosthogService.capture(POSTHOG_EVENT.CARD_ADDED_IN_SIGNUP_FLOW, {
    email,
  });
};

export const cardSkippedEventCapture = (email: string) => {
  PosthogService.capture(POSTHOG_EVENT.CARD_SKIPPED_IN_SIGNUP_FLOW, {
    email,
  });
};

export const userTryReDownload = (email: string) => {
  PosthogService.capture(POSTHOG_EVENT.USER_TRY_REDOWNLOAD, {
    email,
  });
};
//Used until referral is merged
export const cancelSubscriptionClicked = (email: string) => {
  PosthogService.capture(POSTHOG_EVENT.CANCEL_SUBSCRIPTION_CLICKED, {
    email,
  });
};

export const cancelTrialClicked = (email: string) => {
  PosthogService.capture(POSTHOG_EVENT.CANCEL_TRIAL_CLICKED, {
    email,
  });
};

export const manageSubscriptionClicked = (email: string) => {
  PosthogService.capture(POSTHOG_EVENT.MANAGE_SUBSCRIPTION_CLICKED, {
    email,
  });
};
